import * as yup from 'yup';
import { SchemaHelper } from 'modules/application/passport/helpers';

export enum Fields {
  LOAN_NUMBER = 'loanNumber',
  BIRTH_DATE = 'birthDate',
}

/**
 * Схема формы телефона.
 */
export const schema = yup.object().shape({
  /**
   * Номер займа.
   */
  [Fields.LOAN_NUMBER]: yup
    .string()
    .required('Введите номер займа')
    .matches(/^707-\d*$/, 'Неверный формат номера займа (707-*)'),

  [Fields.BIRTH_DATE]: yup
    .string()
    .required('Укажите дату вашего рождения')
    .test(Fields.BIRTH_DATE, function (value) {
      if (!value) {
        return true;
      }

      const { createError } = this;
      const message = SchemaHelper.validateBirthDate(value);

      if (message) {
        return createError({ message });
      }

      return true;
    }),
});

/**
 * Значения схемы.
 */
export type Values = yup.InferType<typeof schema>;
